<template>
  <aside class="manage-page-tools" :id="`manage-tools-${props.key}`">
    <ul v-if="is_organize" class="is-organize">
      <li @click="emit(is_selected_all ? 'deselect-all' : 'select-all')">
        <i><svg-icon :name="is_selected_all ? 'deselect' : 'select'" /></i>
        <span>
          {{ is_selected_all ? 'Deselect all' : 'Select all' }}
        </span>
      </li>

      <el-dropdown trigger="click" popper-class="reorder-dropdown-menu"> 
        <li :class="{ 'is-disabled': !is_can_chronological && selected_items.length === 0 }"> 
          <i><svg-icon name="move" /></i> <span> Reorder </span> 
        </li> 
        <template #dropdown> 
          <label>Options</label> 
           <el-dropdown-menu> 
            <el-dropdown-item @click="emit('move-up')" :disabled="selected_items.length === 0"><svg-icon name="arrow-top" />To Top</el-dropdown-item> 
            <el-dropdown-item @click="emit('move-down')" :disabled="selected_items.length === 0"><svg-icon name="arrow-down" />To Bottom</el-dropdown-item> 
            <el-dropdown-item @click="emit('open-chronological-menu')" v-if="is_can_chronological"><svg-icon name="countdown-left" />Chronological</el-dropdown-item> 
          </el-dropdown-menu>
        </template> 
      </el-dropdown>

      <li
        @click="addTo"
        :class="{ 'is-disabled': selected_items.length === 0 }"
        v-if="route.params.type === 'products'"
      >
        <i><svg-icon name="bookmark" /></i>
        <span> Add to </span>
      </li>
      <li
        @click="emit('hide')"
        :class="{ 'is-disabled': selected_items.filter((o) => o.type !== 'product').length === 0 }"
        v-if="route.params.type !== 'products' && !route.params.type === 'featured'"
      >
        <i><svg-icon :name="is_show_hide ? 'eye-hidden' : 'eye'" /></i>
        <span>
          {{ is_show_hide ? 'Hide' : 'Publish' }}
        </span>
      </li>
      <li @click="emit('delete')" v-if="route.params.type !== 'featured'" :class="{ 'is-disabled': selected_items.length === 0 }">
        <i><svg-icon name="delete" /></i>
        <span> Remove </span>
      </li>
      <li @click="emit('unfeature')" v-if="route.params.type === 'featured'" :class="{ 'is-disabled': selected_items.length === 0 }">
        <i><svg-icon name="star" /></i>
        <span> Unfeature </span>
      </li>
    </ul>

    <ul v-else>
      <li v-if="!props.is_empty" @click="emit('open-manage')">
        <i><svg-icon name="organize" /></i>
        <span> Organize </span>
      </li>
      <li @click="emit('open-add')">
        <i><svg-icon name="plus-filled" /></i>
        <span> Add </span>
      </li>
    </ul>
  </aside>
</template>

<script setup>
import { ref, computed,getCurrentInstance,onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElPopover, ElButton } from 'element-plus';

const emit = defineEmits([
  'open-manage',
  'open-add',
  'open-chronological-menu',
  'select',
  'deselect-all',
  'select-all',
  'move-up',
  'move-down',
  'hide',
  'delete',
  'unfeature',
]);
const route = useRoute();
const app= getCurrentInstance();
const event = app.appContext.config.globalProperties.EventBus;
const props = defineProps({
  is_empty: {
    type: Boolean,
    default: false,
  },
  is_organize: {
    type: Boolean,
    default: false,
  },
  manage_type: {
    type: String,
    default: '',
  },
  selected_items: {
    type: Array,
    default: () => [],
  },
  is_selected_all: {
    type: Boolean,
    default: false,
  },
  key: {
    type: String,
    default: '1',
  },
});

//+++++++++++++++++++++++++++++++++++++++++++++
const addTo = () => {
  const ids = props.selected_items.map((item) => item.product_detail.id);
  event.emit('add-products-to-collections', ids);
};

const is_show_hide = computed(() => {
  return route.params.type !== 'products' && props.selected_items.some((item) => item.is_publish);
});

const is_can_chronological = computed(() => {
  return props.manage_type === 'storefront' && (route.params.type === 'products' || route.params.type === 'collections' || route.params.type === 'posts');
});

//++++++++
//++++++++++++++++++++++++

</script>

<style lang="scss">
.collapsed-sidebar .manage-page-tools {
  left: 64px;
}

.manage-page-tools {
  position: fixed;
  left: var(--el-aside-width);
  right: 0;
  bottom: 0;
  z-index: 9;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  transition: all 0.321s ease;

  ul {
    pointer-events: auto;
    display: flex;
    padding: 16px;
    background-color: var(--Bg-light);
    border-radius: var(--radius-big);
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2), 0px 2px 10px 0px rgba(0, 0, 0, 0.1);

    li {
      width: 48px;
      margin: 0;
      padding: 8px 16px;
      cursor: pointer;
      color: var(--Text-primary);
      border-radius: var(--radius);
      transition: background-color 0.2s;
      box-sizing: content-box;
      position: relative;

      &.is-disabled {
        pointer-events: none;
        opacity: 0.5;
      }

      &:hover {
        background-color: var(--Neu-20);
      }

      i {
        width: 40px;
        height: 40px;
        display: block;
        margin: 0 auto 20px;

        svg {
          width: 100%;
          height: 100%;


        }
        
      }

      span {
        font: var(--medium-12);
        display: block;
        text-align: center;
        margin-top: 4px;
        white-space: nowrap;
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 8px;
      }
    }

    &.is-organize li i {
      height: 32px;
      width: 24px;

      .svg-icon__star {
        width: 30px;
        position: relative;
        left: -2px;
      }
    }
  }

}

.reorder-dropdown-menu {
  .el-dropdown__list {
    padding-bottom: 8px;
    min-width: 160px;

    & > label {
      font: var(--medium-12);
      color: var(--Text-default);
      padding: 8px 16px 0;
      display: block;
    }

    .el-dropdown-menu__item {
      display: flex;
      align-items: center;
      font: var(--medium-14);
      color: var(--Text-primary);
      padding: 10px 16px;

      svg {
        width: 14px;
        height: 14px;
        margin-right: 8px;
        position: relative;

        &.svg-icon__countdown-left {
          height: 16px;
          width: 16px;
          left: -1px;
        }
      }
    }
  }
}
</style>
